import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ARService } from '../../ar/ar.service';
import { CaseFormsService } from '../case-forms.service';
import { TdoTableV2Component } from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableFooterDataModel } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import { DataARLedgerListModel } from '../../ar/models/data-ar-ledger-list.model';
import { cfgCaseProcedure } from '../../ar/_models/ar.models';
import { TdoTableSelectionEvent } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { Globals } from '../../../globals';
import { MessagingService } from '../../../services/messaging.service';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { Constants } from '../../../constants';
import { ProceduresService } from '../../configuration/procedures/procedures.service';

@Component({
  selector: 'app-case-add-procedure',
  templateUrl: './case-add-procedure.component.html',
  styleUrls: ['./case-add-procedure.component.css']
})
export class CaseAddProcedureComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  footerData: TdoTableFooterDataModel[] = [];
  searchPredicate: (data: any, filter: string) => boolean;

  PatientCaseId: string;
  isLoading: boolean = false;
  cfgCaseProcedures: cfgCaseProcedure[] = [];
  selectedCaseProcedure: cfgCaseProcedure[] = [];
  isNewCase: boolean = false;
  isSingleSelection: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CaseAddProcedureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly arService: ARService,
    private readonly snackBar: MatSnackBar,
    private readonly caseService: CaseFormsService,
    private readonly messagingService: MessagingService,
    public readonly globals: Globals,
    private readonly proceduresService: ProceduresService,
  ) {
    this.searchPredicate = (dataSearch: cfgCaseProcedure, filter: string) => {
      const dataCode: string = dataSearch.Code ? dataSearch.Code : '';
      const dataDesc: string = dataSearch.ProcedureName ? dataSearch.ProcedureName : '';
      return dataCode.toLowerCase().includes(filter) || dataDesc.toLowerCase().includes(filter);
    };
  }

  ngOnInit() {
    this.PatientCaseId = this.data.PatientCaseId;
    this.isNewCase = this.data.isNewCase;
    this.isSingleSelection = this.data.isSingleSelection;
    this.init();
  }

  init() {

    this.isLoading = true;

    const promises = [
      this.getCfgCaseProcedures(),
    ];

    Promise.all(promises).then((results: any[]) => {
      this.cfgCaseProcedures = results[0];
      this.cfgCaseProcedures = this.cfgCaseProcedures.filter(p => p.ParentCaseProcedureId === null || p.ParentCaseProcedureId === Constants.emptyGuid);
      this.isLoading = false;
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    });
  }

  getCfgCaseProcedures() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getCfgCaseProcedures(this.globals.LOCID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createProcedure(procedures: cfgCaseProcedure[]) {

    // addProcedureForExistingCase
    // const CaseProcedureId = procedure.CaseProcedureId;
    const CaseProcedures = procedures;
    const PatientCaseId = this.PatientCaseId;

    this.isLoading = true;
    this.caseService.addProcedureForExistingCaseCaseView(PatientCaseId, CaseProcedures)
      .subscribe(response => {
        this.createMessage('Procedure added to the case', 'Success');
        this.isLoading = false;
        this.cancel(true);
        if (!PatientCaseId) {
          this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, response);
        }
      }, err => {
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
      });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    const procedure = this.cfgCaseProcedures.find(p => p === event.model);
    // this.selectedCaseProcedure = [];
    if (procedure) {
      procedure.DATA_SELECTED = event.isSelected;

      if (event.isSelected) {
        if (!this.selectedCaseProcedure.includes(procedure)) {
          this.selectedCaseProcedure.push(procedure);
        }
      } else {
        const idx = this.selectedCaseProcedure.findIndex(p => p === procedure);
        if (idx > -1) {
          this.selectedCaseProcedure.splice(idx, 1);
        }
      }
    }
  }

  cancel(payload) {
    this.dialogRef.close(payload);
  }

  saveProcedure() {
    if (this.selectedCaseProcedure) {
      if (this.data.isAddCodeNotFound) {
        this.addProcedureCode(this.data.searchCode, this.data.doctorId, this.data.patientId, this.selectedCaseProcedure);
      }
      else if (!this.isNewCase) {
        this.createProcedure(this.selectedCaseProcedure);
      }
      else {
        this.dialogRef.close(this.selectedCaseProcedure[0]);
      }
    }
  }
  addProcedureCode(searchCode: string, doctorId: string, patientId: string, selectedCaseProcedure: cfgCaseProcedure[]) {
    this.isLoading = true;
    this.proceduresService.createProcedureCode(searchCode, doctorId, patientId, selectedCaseProcedure[0]).subscribe((result) => {
      if(result){
        this.createMessage('Procedure Code added successfully', 'Success');
        this.isLoading = false;
        this.cancel(true);
      }
    },
    err => {
      console.log('Error adding Procedure Code', err);
      this.createMessage('Error adding Procedure Code', 'Error');
      this.isLoading = false;
    });
  }

}
